import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	buttonLabelGenerateFromConfluence: {
		id: 'backlog.card-list.inline-card-create.ai-assisted-create.hover-box.button-label-generate-from-confluence',
		defaultMessage: 'Generate from Confluence',
		description:
			'Copy for a button used to generate work items from confluence page with AI in backlog.',
	},
	buttonLabelGenerateFromImage: {
		id: 'backlog.card-list.inline-card-create.ai-assisted-create.hover-box.button-label-generate-from-image',
		defaultMessage: 'Generate from image',
		description: 'Copy for a button used to generate work items from image with AI in backlog.',
	},
});
